import { render, staticRenderFns } from "./niangjiu.vue?vue&type=template&id=5d4efc83&"
import script from "./niangjiu.vue?vue&type=script&lang=js&"
export * from "./niangjiu.vue?vue&type=script&lang=js&"
import style0 from "./niangjiu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports